var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c("el-input", {
            attrs: { placeholder: _vm.placeholder, "data-bot": _vm.dataBot },
            on: { change: _vm.update, blur: _vm.formatAmount },
            scopedSlots: _vm._u(
              [
                _vm.numberFormat.currencypos == "right"
                  ? {
                      key: "append",
                      fn: function() {
                        return [_vm._v(_vm._s(_vm.symbol))]
                      },
                      proxy: true
                    }
                  : null,
                _vm.numberFormat.currencypos == "left"
                  ? {
                      key: "prepend",
                      fn: function() {
                        return [_vm._v(_vm._s(_vm.symbol))]
                      },
                      proxy: true
                    }
                  : null
              ],
              null,
              true
            ),
            model: {
              value: _vm.currentValue,
              callback: function($$v) {
                _vm.currentValue = $$v
              },
              expression: "currentValue"
            }
          })
        : _c("p", [
            _vm._v(
              _vm._s(_vm.currentValue) +
                " " +
                _vm._s(_vm.numberFormat.currencysymbol)
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }